export const environment = {
    "name":'dev',
    "firebaseConfig": {
        projectId: "usaremix-dev",
        appId: "1:331768956312:web:246d4bd8f3b815521f97ed",
        apiKey: "AIzaSyBZ_51ikvGnVhZp0uKPf7DD3qeqGW0cZBU",
        authDomain: "usaremix-dev.firebaseapp.com",
        messagingSenderId: "331768956312",
        measurementId: "G-QF8M8JW6YQ",
        storageBucket: "usaremix-dev.firebasestorage.app",
      },
    "firestoreDb": "usaremix-dev-db",
};
